/**
 * @description
 * Objeto setvalues
 */

import { Wsdefs } from "./wsdefs.model";

export class Setvalues {
    public id:number = null;
    public code:string = "";
    public type:string = "SetvalueWscategory";
    public descrip:string;
    public numorder:number = null;
    public wsdefs: Wsdefs[] = [];
    public cat:string;
    public esp:string;
    public ciutada_cat:string;
    public ciutada_esp:string;
    public empresa_cat:string;
    public empresa_esp:string;
    public proveidor_cat:string;
    public proveidor_esp:string;

    constructor() {
        this.wsdefs = new Array<Wsdefs>();
    }
  
}